import GameManager from '../../../core/GameManager';
import { ScenarioSceneType, ScenarioEndType } from '../../../misc/BleedingControlScenario';
import MainPracticeScenario from './MainTestScenario/MainTestScenario';
import { constants } from '../../../misc/helpers';
import {getTestBScenario} from './testStartText';

export default class PracticeScenarioB extends MainPracticeScenario {
	constructor(gameManager: GameManager, scenarioName: string) {
		var locations = [
			{
				type: constants.placementType.wrong,
				position: 60,
			},
			{
				type: constants.placementType.correct1,
				position: 34,
			},
		];

		var correctT1 = 1;
		var wrongT1 = 2;

		super(gameManager, scenarioName, ScenarioSceneType.scenarioB, ScenarioEndType.firstTourniquete, [], true, 0.57, 0.80, locations, null, correctT1, null, wrongT1, null, false, true, false, false, 'Circular Saw Injury - Test Scenario', getTestBScenario());
	}


	public get totalNumberOfQuestions(): number {
		return 11;
	}

	public soundFolderAndPath(section: string, part: string): string {
		return '07-Scenario B/BC-Scenario-B-'  + section + '-Part-' + part;
	}
}